import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Some browser extensions inject Tailwind v4 CSS that registers the gradient
// variables as typed properties (e.g. `@property --tw-gradient-from { syntax:
// "<color>" }`). Tailwind v3's values don't match those types, so every
// gradient on the page turns transparent (white-on-white buttons, invisible
// gradient text). Registrations made from JS take precedence over @property
// rules, so re-register them as untyped to keep our gradients rendering.
if (window.CSS && CSS.registerProperty) {
  ['from', 'via', 'to', 'from-position', 'via-position', 'to-position'].forEach((v) => {
    try {
      CSS.registerProperty({ name: `--tw-gradient-${v}`, syntax: '*', inherits: false });
    } catch (e) {
      // Already registered (e.g. module re-run) - nothing to do.
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);